export function isStringifiedQuillDelta(value: unknown): boolean {
  if (typeof value !== 'string') return false

  const trimmed = value.trim()

  if (!trimmed.startsWith('{') || !trimmed.endsWith('}') || !trimmed.includes('"ops"')) {
    return false
  }

  try {
    const parsed = JSON.parse(trimmed)
    return typeof parsed === 'object' && parsed !== null && Array.isArray(parsed.ops)
  } catch {
    return false
  }
}
